import { css } from '@emotion/react'
import { medium, small } from '../../GlobalStyles'

export const SideBarStyle = css`

    height: 100%;
    background: var(--sidebar-bg);
    position: relative;
    &:before{
        content: '';
        width: 100%;
        height: 50px;
        display: block;
        position: absolute;
        top: -50px;
        left: 0px;
        background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(246,247,249,1) 100%);
    }

    ${medium}{
        
        position: fixed;
        display: none;
        max-height: 100vh;
        &::-webkit-scrollbar {
            display: none;
        }
        overflow: scroll;
        & >  aside{
            position: static!important;
        }
        .menuOpen &{
            display: block;
            top: 0px;
            padding-top: 70px;
            box-shadow: 2px 2px 5px -2px #282c34;   
            z-index: 1;
            min-width: 60%;

        }
        .stickyMode.menuOpen &{
            padding-top: 60px;
        }
    }

    ${small}{
        .menuOpen &{
            min-width: 75%;
        }
    }


    & > aside {
        .stickyMode &{
            transform: translateY(-15px);
        }
        width: 100%;
        padding-left: 0;
        top: 75px;
        padding: 0 2px 50px 2px;
        position: sticky;
        transition: all 0.4s ease;

        max-height: calc(100vh - 75px);
        overflow-y: scroll;
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        scrollbar-width: none;  /* Firefox */
        &::-webkit-scrollbar { 
            display: none;  /* Safari and Chrome */
        }

    }

`

export const SideBarListStyle = css`

    transition: all 0.4s ease;
    padding-top: 10px;
    .stickyMode &{
        margin-top: 0px;
    }

    margin-top: 16px;
    li {
        list-style-type: none;
        width: auto;
    }  
    li a {
        color: #aaa;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.5;
        padding: 8px 24px 8px 16px;
        padding-left: 10px;
        padding-right: 25px;
        outline-offset: -2px;
    }



    .item{
        list-style: none;
        padding: 0;
        margin-left: 16px;
        position: relative;

        & > a {
            color: var(--cool-gray);
            text-decoration: none;
            display: inline-block;
            position: relative;
            width: 100%;
            box-shadow: inset 0px 0px 0px 0px var(--primary-color);
            padding: 10px 1em 10px 10px;
            &:hover{
                background-color: #fff;
            }
        }

        &.active > a{
            background-color: #fff;
            border-left: 3px solid #000;
        }

        a{
            border-left: 3px solid transparent;
        }

        &.firstLevel {

            margin-left: 0px;

            ul .item ul .item {
                border-left: 1px solid #B5BABE;
            }

            > ul > .item {
                margin-left: 0 !important;
            }

        }

        .collapser{
            background: transparent;
            border: none;
            top: 0;
            height: 41px;
            width: 40px;
            position: absolute;
            right: 0px;
            z-index: 1;
            fill: #B5BABE;
            &:hover,
            &:focus-visible{
                fill: var(--cool-gray);
            }
            outline-offset: -2px;
        }
        
        .subItem a {
            color: #656d75;
            font-weight: 400;
        }

        .subSubItem a {
            font-weight: 400;
        }
    }
    .showFrontLine  .item .item{
        border-left: 1px solid #aaa;
        border-left-color: rgb(230, 236, 241);
        padding: 0;
        width: calc(100% - 16px) !important;
    }

    .showFrontLine .item .active>a {
        border-color: #aaa !important;
        border-style: solid none solid solid;
        border-width: 1px 0px 1px 1px;
        text-decoration: underline;
    }

`

